module.exports = __webpack_public_path__ + "static/media/4.58e1d6f1.png";